import 'init/application'
import { initialize } from 'quick-win/download/index'

initialize()
